import { createAction, createReducer } from 'deox';

import { StoreLocation } from 'hooks/requests/storeLocations';

export interface StoreLocationsState {
  entities: StoreLocation[] | null;
}

const defaultState: StoreLocationsState = {
  entities: null,
};

export const setStoreLocations = createAction(
  'SET_STORE_LOCATIONS',
  resolve => (storeLocations: StoreLocation[]) => resolve({ storeLocations }),
);

export const storeLocationsReducer = createReducer(
  defaultState,
  handleAction => [
    handleAction(
      setStoreLocations,
      (state, { payload: { storeLocations } }) => ({
        ...state,
        entities: storeLocations,
      }),
    ),
  ],
);

export interface MountedState {
  storeLocations: StoreLocationsState;
}

export const selectStoreLocations = (
  state: MountedState,
): StoreLocation[] | null => state.storeLocations.entities;

export default storeLocationsReducer;
